export interface IEnhancedContentResponse {
    content: string;
}

export class EnhancedContentResponse implements IEnhancedContentResponse {
    public content: string;
    public province: string;
    public city: string;

    constructor(province: string, city: string, data: string) {
        if (data) {
            this.province = province;
            this.city = city;
            this.content = data;
        }
    }
}
